<template>
 <nav class="navbar navbar-light bg-white mt-3 px-md-4 p-0">
    <div class="container pl-2 pl-md-3 pr-2 pr-md-3">
        <router-link :to="{name: 'Home'}" class="navbar-brand">
            <img src="../../assets/logo-full.png" alt="Logo of GoNHS TAYSIDE"/>
            <img src="../../assets/nhs/tactran.png" alt="Tactran logo"/>
        </router-link>
        <p class="d-none d-md-block"><strong>Need support or having problems? </strong>
            <a href="https://support.gonhstayside.co.uk/portal/en/kb" target="_blank" class="ml-2">
                <strong>Get help</strong>
            </a>
        </p>
        <a href="https://support.gonhstayside.co.uk/portal/en/kb" target="_blank" class="d-md-none">
            <strong>Get help</strong>
        </a>
        </div>
    </nav>
</template>

<script>


export default {

    dara() {
        return {

        }
    },
}
</script>
